import Wrapper from 'xpi-black-ui/Base/Wrapper';
import styled from 'styled-components';
import { Text } from 'xpi-black-ui/Base/Typography';

const WrapperTable = styled(Wrapper)`
  @media only screen and (min-width: 0px) {
    min-width: 87%;
  }

  @media only screen and (min-width: 2500px) {
    min-width: 100%;
  }
`;

export const Link = styled(Text)`
  text-decoration: none;
  color: 'white';
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-top: 0.5rem;

  a:link {
    color: white;
    text-decoration: none;
  }

  a:visited {
    color: white;
    text-decoration: none;
  }

  a:hover {
    color: white;
  }

  a:active {
    color: white;
    text-decoration: none;
  }
`;

export default WrapperTable;
